export default {
  stats: {
    orders: 'Pedidos',
    sales: 'Ingresos',
  },
};
